/* eslint-disable @typescript-eslint/naming-convention */
export enum FeatureFlagEnum {
  TRANSHIPMENT_APP_BARGING_SCHEDULE = "transhipment-app-barging-schedule",
  PORT_APP = "port-app",
  PORT_ASSISTANT = "port-assistant",
  SMART_SEARCH_APP = "smart-search-app",
  CHARTERER_APP = "charterer-app",
  TRANSHIPMENT_APP = "transhipment-app",
  PORT_CALL_APP = "port-call-app",
  PORT_CALL_PRE_ARRIVAL_WASTE_UWC_FROM_FORM_VALUES = "port-call-pre-arrival-waste-uwc-from-form-values",
  TERMINAL_APP = "terminal-app",
  SMART_SEARCH_CONVERSATION_V2 = "smart-search-conversation-v2",
  COLLABORATION_APP = "collaborative-container-app",
}
